import * as p from "react";
import * as f from "react-dom";
import { createSlot as c } from "../../../../../@radix-ui_react-slot@1.2.3_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-slot/dist/index.js";
import { j as u } from "../../../../../../../_virtual/jsx-runtime.js";
var l = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], h = l.reduce((t, i) => {
  const o = c(`Primitive.${i}`), r = p.forwardRef((e, s) => {
    const { asChild: m, ...a } = e, n = m ? o : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u.jsx(n, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${i}`, { ...t, [i]: r };
}, {});
function w(t, i) {
  t && f.flushSync(() => t.dispatchEvent(i));
}
export {
  h as Primitive,
  w as dispatchDiscreteCustomEvent
};
